import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NGXLogger } from 'ngx-logging-kit';

export const httpLogInterceptor: HttpInterceptorFn = (request, next) => {
	const logger = inject(NGXLogger);

	const endpoint = request.urlWithParams;
	logger.info(request.method + ' ' + endpoint);

	return next(request);
};
